import { Alert, Button } from "@heroui/react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { useLocation } from "react-router-dom";

const PageErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => (
  <Alert status="danger">
    <Alert.Indicator />
    <Alert.Content>
      <Alert.Title>This page crashed</Alert.Title>
      <Alert.Description>
        {error instanceof Error ? error.message : String(error)}
      </Alert.Description>
    </Alert.Content>
    <Button size="sm" variant="secondary" onPress={resetErrorBoundary}>
      Try again
    </Button>
  </Alert>
);

export const PageErrorBoundary = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary FallbackComponent={PageErrorFallback} resetKeys={[pathname]}>
      {children}
    </ErrorBoundary>
  );
};
